export default __webpack_public_path__ + "static/media/Strap_Steel_Black.be6c845d.png";